module.exports = __webpack_public_path__ + "img/4-5.70243139.svg";